module.exports = __webpack_public_path__ + "static/media/lease4_img2.a2438d76.jpg";